import React from "react";
import { Box, Button, CircularProgress, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { SimpleTextInput } from "components/FormTextInput";
import { Save } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    borderRadius: theme.spacing(1),
    backgroundColor: "#ffffff",
    border: "1px solid #e0e0e0",
  },
  sectionTitle: {
    fontWeight: "600",
    color: "#333333",
    marginBottom: theme.spacing(1),
    borderBottom: "2px solid #f0f0f0",
    paddingBottom: theme.spacing(1),
  },
  sectionSubtitle: {
    marginBottom: theme.spacing(3),
    color: "#666666",
  },
  vaultConfigContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr auto",
    gap: theme.spacing(3),
    alignItems: "end",
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
      gap: theme.spacing(2),
    },
  },
  inputField: {
    width: "100%",
  },
  sectionSaveButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#4caf50",
    color: "white",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#45a049",
    },
    "&:disabled": {
      backgroundColor: "#e0e0e0",
      color: "#9e9e9e",
    },
  },
}));

const VaultConfiguration = ({
  vaultConfigDetails,
  onVaultConfigChange,
  onVaultConfigSave,
  vaultConfigSaveLoading,
}) => {
  const styles = useStyles();

  return (
    <Paper elevation={1} className={styles.paperContainer}>
      <Box>
        <Typography variant="h6" className={styles.sectionTitle}>
          Vault Configuration
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          className={styles.sectionSubtitle}
        >
          Configure experience points and growth rate settings for the
          operator vault
        </Typography>
      </Box>

      <Box style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", marginBottom: "16px" }}>
        <Box>
          <SimpleTextInput
            label="Base XP"
            type="number"
            name="baseXP"
            placeholder="Enter base experience points"
            value={vaultConfigDetails.baseXP}
            onChange={onVaultConfigChange}
            className={styles.inputField}
          />
        </Box>

        <Box>
          <SimpleTextInput
            label="Growth Rate"
            name="growthRate"
            type="number"
            placeholder="Enter growth rate percentage"
            value={vaultConfigDetails.growthRate}
            onChange={onVaultConfigChange}
            className={styles.inputField}
          />
        </Box>
      </Box>

      {/* Section Save Button */}
      <Box display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          onClick={onVaultConfigSave}
          disabled={vaultConfigSaveLoading}
          startIcon={
            vaultConfigSaveLoading ? (
              <CircularProgress size={20} />
            ) : (
              <Save />
            )
          }
          className={styles.sectionSaveButton}
        >
          {vaultConfigSaveLoading ? "Saving..." : "Save Vault Config"}
        </Button>
      </Box>
    </Paper>
  );
};

export default VaultConfiguration;